<mat-dialog-content>
    <h2 class="title">Material hochladen</h2>
  
    <form [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Titel</mat-label>
        <input matInput formControlName="materialName" />
      </mat-form-field>
  
      <div
        class="upload-box"
        [class.drag-over]="isDragOver"
        (click)="fileInput.click()"
      >
        <input type="file" hidden #fileInput (change)="onFileSelected($event)" accept=".mp4,.mov,video/mp4,video/quicktime"/>
        <mat-icon>cloud_upload</mat-icon>
        <div>
          {{ fileName || 'Datei Upload' }}
        </div>
        <small class="file-info">Max. 1 GB, Formate: .mov, .mp4</small>
      </div>
  
      <div class="actions">
        <button mat-button (click)="closeDialog()" class="secondary-button">Abbrechen</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="uploadForm.invalid">
            Speichern
          </button>
      </div>
    </form>
  </mat-dialog-content>